import { Pipe, PipeTransform } from '@angular/core';

import * as dayjs from 'dayjs';

@Pipe({
  standalone: true,
  name: 'tmwTime',
})
export default class TmwTimePipe implements PipeTransform {
  transform(day: any): string {
    return day ? dayjs(day).format('HH:mm') : '';
  }
}
